import { FormattedMessage } from 'dibs-react-intl';

export const deliveryTitle = (
    <FormattedMessage id="pdpBlurb.deliveryTitle" defaultMessage="Shipping: " />
);

export const leadTimeTitle = (
    <FormattedMessage id="pdpBlurb.leadTimeTitle" defaultMessage="Estimated Production Time:" />
);

export const shipsFrom = (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.requestQuoteOverviewShipsFrom"
        defaultMessage="Ships From: "
    />
);

export const shipsFromLocation = itemLocation => (
    <FormattedMessage
        id="pdp.PdpSharedBlurbShippingCustomQuote.requestQuoteOverviewShipsFromLocation"
        defaultMessage="{itemLocation}"
        values={{ itemLocation }}
    />
);
